import vine from '@vinejs/vine'

/** Libellé court d'entité d'organisation (dirLib, domLib, ageLib, equLib, tagLib). */
export function orgLibField(maxLength = 68) {
  return vine.string().trim().maxLength(maxLength)
}

export function optionalLongLabelField() {
  return vine.string().trim().maxLength(255).nullable().optional()
}

/** Compile deux fois le même schéma (création et mise à jour identiques). */
export function createAndUpdateValidator<Schema>(buildSchema: () => Schema) {
  return {
    create: vine.create(buildSchema() as never),
    update: vine.create(buildSchema() as never),
  }
}
